import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Layout } from '@components';
import Games from '@components/sections/games';

const StyledMain = styled.main`
  &.fillHeight {
    padding: calc(var(--nav-height) + 60px) 150px 0;

    @media (max-width: 1080px) {
      padding: calc(var(--nav-height) + 60px) 100px 0;
    }
    @media (max-width: 768px) {
      padding: calc(var(--nav-height) + 50px) 50px 0;
    }
    @media (max-width: 480px) {
      padding: calc(var(--nav-height) + 45px) 25px 0;
    }
  }

  header {
    max-width: 900px;
  }

  .intro {
    margin-top: 10px;
    max-width: 620px;
  }
`;

const GamesPage = ({ location }) => (
  <Layout location={location}>
    <Helmet
      title="Games"
      meta={[
        {
          name: 'description',
          content:
            'Games and interactive mini projects that you can play directly in your browser.',
        },
      ]}
    />

    <StyledMain className="fillHeight">
      <header>
        <h1 className="big-heading">Games</h1>
        <p className="intro">Mini projects you can play in the browser.</p>
      </header>

      <Games limit={null} showHeading={false} showViewAllLink={false} sectionId="games-list" />
    </StyledMain>
  </Layout>
);

GamesPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default GamesPage;
